export default __webpack_public_path__ + "static/media/history.e3c9950c.svg";